import React, { useCallback } from 'react'
import classnames from 'classnames'

import { TtButton, TtIcon } from '@23/ui-react'

import {
  switchToCustomMix,
  useFloorState,
} from '../../../../firebase/hooks/useFloor'
import {
  setEditingMix,
  useIsEditingMix,
} from '../../../../firebase/hooks/useMixes'
import { cleanupTransientChyrons } from '../../../../firebase/hooks/useOverlays'
import { useLastActiveMediaTrayCard } from '../../../../firebase/hooks/useTray'
import type { Mix } from '../../../../firebase/model/mix'
import type { DeepReadonly } from '../../../../firebase/typeUtils'
import usePlaybackIntent from '../../../../Webinar/hooks/usePlaybackIntent'
import { MixPreview } from '../MixPreview/MixPreview'

import './CustomMix.scss'

interface CustomMixProps {
  mix: DeepReadonly<Mix>
}

const CustomMix = ({ mix }: CustomMixProps) => {
  const floor = useFloorState()
  const isEditingMix = useIsEditingMix(mix.id)
  const lastActiveMediaCard = useLastActiveMediaTrayCard()
  const { setPlaybackResumeIntent } = usePlaybackIntent()

  const isLive = floor?.layout === 'custom' && floor.mixId === mix.id

  const handleClick = useCallback(() => {
    void switchToCustomMix(mix.id)
    void cleanupTransientChyrons()

    if (lastActiveMediaCard?.type === 'video') {
      void setPlaybackResumeIntent()
    }
  }, [lastActiveMediaCard?.type, mix.id, setPlaybackResumeIntent])

  return (
    <button
      type="button"
      className={classnames('custom-mix-trigger', {
        'is-editing': isEditingMix,
      })}
      onClick={handleClick}
      data-active={isLive}
    >
      <MixPreview mix={mix} />
      <div className="custom-mix-settings-baseline">
        <div>{mix.name}</div>
        <div className="custom-mix-settings-button-zone">
          <TtButton
            className="custom-mix-settings-button"
            color="secondary"
            variant="light"
            size="x-small"
            onClick={(event) => {
              event.stopPropagation()
              setEditingMix(isEditingMix ? null : mix.id)
            }}
          >
            <TtIcon library="23" name="cog" />
          </TtButton>
        </div>
      </div>
    </button>
  )
}

export { CustomMix }
